import { render, staticRenderFns } from "./addmodal.vue?vue&type=template&id=67e9f888&scoped=true&"
import script from "./addmodal.vue?vue&type=script&lang=js&"
export * from "./addmodal.vue?vue&type=script&lang=js&"
import style0 from "./addmodal.vue?vue&type=style&index=0&id=67e9f888&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9f888",
  null
  
)

export default component.exports